import React from "react";
import { PageHero, CTABlock, SectionLabel } from "@/components/Sections";
import { ASSETS } from "@/lib/data";
import { Heart, ShieldCheck, MapPin, Award, Users, RefreshCcw } from "lucide-react";

const values = [
  { icon: Users, title: "Samma person", text: "Samma kontakt vid återkommande uppdrag när det är möjligt." },
  { icon: RefreshCcw, title: "Städgaranti", text: "Inte nöjda? Vi åtgärdar utan extra kostnad." },
  { icon: ShieldCheck, title: "Försäkrade", text: "Ansvarsförsäkring upp till 10 miljoner." },
  { icon: Award, title: "Alla försäkringar", text: "Vi har alla försäkringar som krävs för uppdraget." },
  { icon: MapPin, title: "Lokal närvaro", text: "Vi finns i Bjuv och arbetar i hela nordvästra Skåne." },
  { icon: Heart, title: "Personlig service", text: "Vi går in helhjärtat i varje projekt – stort som litet." },
];

export default function OmOss() {
  return (
    <>
      <PageHero
        eyebrow="Om företaget"
        title="Lokal städfirma med hjärta och engagemang"
        intro="Vi brinner för det vi gör och går alltid in helhjärtat i varje uppdrag. Hos Rena Tjänster får ni personlig service och en trygg kontakt genom hela uppdraget."
        image={ASSETS.about}
        imageAlt="Lokal kontorsmiljö – Rena Tjänster"
      />

      <section className="py-20 lg:py-28" data-testid="om-values">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionLabel className="mb-4">Det här står vi för</SectionLabel>
          <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mb-12 max-w-2xl">
            Trygghet, kvalitet och lokal närvaro
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {values.map((v, i) => (
              <div key={i} className="bg-white rounded-2xl p-7 border border-slate-100 hover:shadow-md transition-all" data-testid={`om-value-${i}`}>
                <div className="w-11 h-11 rounded-xl bg-[#1E3A6F]/8 text-[#1E3A6F] inline-flex items-center justify-center mb-4">
                  <v.icon className="h-5 w-5" strokeWidth={1.6} />
                </div>
                <h3 className="font-display text-lg font-semibold text-slate-900 mb-1.5">{v.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-28 bg-white border-y border-slate-100" data-testid="om-story">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <SectionLabel className="justify-center mb-4">Vår känsla</SectionLabel>
          <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mb-6">
            Varm, lokal och pålitlig
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Vi har vår bas i Bjuv och arbetar dagligen i hela nordvästra Skåne. För oss handlar
            städning om mer än bara rena ytor – det handlar om att skapa en känsla av lugn och
            välmående i varje lokal. Vi tror på personliga relationer, raka besked och städning
            som ni kan lita på.
          </p>
        </div>
      </section>

      <CTABlock
        title="Vill ni veta mer om oss?"
        description="Hör av er – vi pratar gärna städning och berättar mer om hur vi kan hjälpa just er verksamhet."
      />
    </>
  );
}
